import { render } from "./Mobilebar.vue?vue&type=template&id=37c3b846"
import script from "./Mobilebar.vue?vue&type=script&lang=js"
export * from "./Mobilebar.vue?vue&type=script&lang=js"

import exportComponent from "C:\\WORK\\Tamani\\admin-landing\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__